module.exports = __webpack_public_path__ + "static/media/2023-VC-Feature-Banner-Mobile@1x.1b35b770.jpg";